import vars from '../common/vars';
import { isDevBuild } from '../common/utils/environment';

if (!isDevBuild()) {
  __webpack_public_path__ = vars.get('ASSET_LOC'); // eslint-disable-line camelcase, no-undef
}
